<block-ui> </block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="LocalizationForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="LocalizationForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->

          <div ngbDropdown class="d-inline-block" [ngStyle]="{'display': ShowPageContent==true?'block':'none'}">
            <button ngbDropdownToggle href="javascript:;" type="button" class="btn btn-sm btn-light-primary me-3" id="FiltersDropdown" title="Filter">
              <i class="fas fa-filter me-1"></i>
              {{utilityService.getResourceValue("Filter")}}
            </button>
            <div *ngIf="IsFilterLoaded" ngbDropdownMenu aria-labelledby="FiltersDropdown" class=" filter-container menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary  w-250px w-md-500px fw-bold py-3 ">
              <form [formGroup]="LocalizationForm">
                <div class="px-7 py-5">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="mb-10">
                        <BBSF-DropdownList [options]="ResourceSetOptions" [group]="LocalizationForm"></BBSF-DropdownList>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-light btn-active-light-primary pv-reset btn-sm" id="applyFiltersBtn"
                            (click)="resetFilters()">
                      {{utilityService.getResourceValue("Reset")}}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <button (click)="exportExcel()"
                  title="Export" type="button" class="btn btn-sm btn-light-primary bnsights-btn-export me-3 ">
            <i class="fas fa-download me-1"></i>
            {{utilityService.getResourceValue("Export")}}
          </button>

          <button id="btnActivate" type="button" class="btn btn-sm btn-light-primary me-3 " (click)="showConfirmationModal(1,ConfirmationModal)">
            <i class="fas fa-sync-alt me-1"></i>
            {{utilityService.getResourceValue("Reload")}}
          </button>
          <button type="button" class="btn btn-sm btn-primary me-3 " id="btnActivate" (click)="ShowUploadModal(UploadJsonFileModal)">
            <i class="fas fa-upload me-1"></i>
            {{utilityService.getResourceValue("Upload")}}
          </button>
          <button type="button" class="btn btn-sm btn-primary me-3" (click)="showAddResourceModal(AddResourceModal)">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>
          <div>
            <button mat-button [matMenuTriggerFor]="menut" class="btn btn-sm btn-primary me-3 btn-icon" title="options">
              <i class="fa fa-bars"></i>
            </button>
            <mat-menu #menut="matMenu" class="py-3">
              <button ngbDropdownItem type="button" class="menu-item px-3" (click)="showConfirmationModal(2,ConfirmationModal)">
                <span class="menu-link px-3">  {{utilityService.getResourceValue("RestToFactoryDefault")}}</span>
              </button>
              <button ngbDropdownItem *ngIf="!ProductionMode" type="button" class="menu-item px-3" (click)="GenerateStronglyTypedClass(GenerateStronglyTypedModal)">
                <span class="menu-link px-3">  {{utilityService.getResourceValue("GenerateStronglyTypedClass")}} </span>
              </button>
            </mat-menu>
          </div>
          <!-- end::Menu -->
        </div>
      </div>
      <!-- end::Header -->
      <!-- begin::Body -->
      <div class="card-body py-3">
        <div class="table-responsive">
          <!-- begin::Table -->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("ResourceId")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("ResourceSet")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("English")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Arabic")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
              <tr *ngFor="let Localization of LocalizationPagingResult">
                <td class="text-dark">{{Localization.resourceId}}</td>
                <td>{{Localization.resourceSet}}</td>
                <td>{{Localization.valueEN}}</td>
                <td>{{Localization.valueAR}}</td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a ngbDropdownItem class="menu-item px-3" (click)="showEditResourceModal(Localization,EditResourceModal)">
                        <span class="menu-link px-3">  {{utilityService.getResourceValue("Edit")}}</span>
                      </a>
                      <a ngbDropdownItem *ngIf="!ProductionMode" class="menu-item px-3" (click)="showDeleteResourceModal(Localization,deleteResourceModal)">
                        <span class="menu-link px-3">  {{utilityService.getResourceValue("Delete")}} </span>
                      </a>
                    </mat-menu>
                  </div>

                </td>
              </tr>
              <tr *ngIf="LocalizationPagingResult.length == 0">
                <td colspan="5">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
          <!--end::users list-->
        </div>
      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setLocalizationListResult($event)" *ngIf="IsFilterLoaded" [options]="LocalizationPaging"
                     [group]="LocalizationForm" #LocalizationPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>



  <!-- Add Modal -->
  <ng-template #AddResourceModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("AddResource")}}</h1>
      </div>
      <form [formGroup]="AddResourceForm" (ngSubmit)="addResource()">
        <BBSF-AutocompleteTextBox [options]="ResourceSet" [group]="AddResourceForm">
        </BBSF-AutocompleteTextBox>
        <BBSF-TextBox [options]="ResourceId" [group]="AddResourceForm">
        </BBSF-TextBox>
        <BBSF-MultiLingualTextArea [options]="MultiLingualValue" [group]="AddResourceForm"></BBSF-MultiLingualTextArea>
        <BBSF-MultiLingualTextArea [options]="MultiLingualComment" [group]="AddResourceForm"></BBSF-MultiLingualTextArea>
        <div class="text-center pt-7">
          <button type="button" #CloseResourceModal id="CloseResourceModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>

  <!-- Edit Modal -->
  <ng-template #EditResourceModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("EditResource")}}</h1>
      </div>
      <form [formGroup]="EditResourceForm" (ngSubmit)="editResource()">
        <BBSF-MultiLingualTextArea [options]="EditMultiLingualValue" [group]="EditResourceForm"></BBSF-MultiLingualTextArea>
        <BBSF-MultiLingualTextArea [options]="EditMultiLingualComment" [group]="EditResourceForm"></BBSF-MultiLingualTextArea>

        <div class="text-center pt-7">
          <button type="button" #CloseEditResourceModal id="CloseEditResourceModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>

  <!-- Upload Modal -->
  <ng-template #UploadJsonFileModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("UploadResources")}}</h1>
      </div>
      <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed mb-10 p-6">
        <!--begin::Icon-->
        <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
        <span class="svg-icon svg-icon-2tx svg-icon-primary me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>
        <!--end::Svg Icon-->
        <!--end::Icon-->
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack flex-grow-1">
          <!--begin::Content-->
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("UploadJsonResourcesInfo")}}
            </div>
          </div>
          <!--end::Content-->
        </div>
        <!--end::Wrapper-->
      </div>
      <form [formGroup]="UploadJsonFileForm" (ngSubmit)="UploadExcelFiles()">
        <a [hidden]="true" id="ShowResourceValidationModal" href="javascript:;" (click)="openResourceValidationModal(ResourceValidationModal)">
          <i class="fa fa-history"></i> {{utilityService.getResourceValue("show")}}
        </a>
        <BBSF-FileUplaod [options]="ResourcesFileInput" [group]="UploadJsonFileForm">
        </BBSF-FileUplaod>
        <a id="btnDeactivate" href="javascript:;" (click)="exportExcel(true)">
          {{utilityService.getResourceValue("DownloadResourceTemplateSheet")}}
        </a>
        <div class="text-center pt-7">
          <button type="button" #CloseUploadJsonFileModal id="CloseUploadJsonFileModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>


  <!-- Delete  Modal -->
  <ng-template #deleteResourceModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("Resource")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteResourceModal id="CloseDeleteResourceModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteResource()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>

  <!-- GenerateStronglyTypedClass  Modal -->
  <ng-template #GenerateStronglyTypedModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("GenerateCode")}}</h1>
      </div>
      <form [formGroup]="GenerateCodeForm">
        <div>
          <BBSF-TextArea [options]="StronglyTypedClass" [group]="GenerateCodeForm">
          </BBSF-TextArea>

        </div>
        <div class="text-center pt-7">
          <button type="button" #CloseStronglyTypedClassModal id="CloseStronglyTypedClassModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="copyInputMessage()">
            {{utilityService.getResourceValue("CopyToClipboard")}}
          </button>
        </div>
      </form>



    </div>
  </ng-template>


  <!-- Confirmation Message  Modal -->
  <ng-template #ConfirmationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{HeaderMessage}}</h1>
      </div>
      <div>
        {{ConfirmationMessage}}
      </div>
      <div class="text-center pt-7">
        <button type="button" #CloseConfirmationModal id="CloseConfirmationModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
        <button type="button" *ngIf="ConfirmationModalType==2" (click)="RestToFactoryDefault()"
                class="btn btn-danger btn-sm">
          {{utilityService.getResourceValue("ResetToFactoryDefault")}}
        </button>
        <button type="button" *ngIf="ConfirmationModalType==1" (click)="ReloadJsonFile()"
                class="btn btn-danger btn-sm">
          {{utilityService.getResourceValue("Reload")}}
        </button>
      </div>

    </div>
  </ng-template>

  <!-- Resource Validation Modal-->
  <ng-template #ResourceValidationModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("ResourcecheckResult")}}</h1>
      </div>
      <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
        <!--begin::Icon-->
        <!--begin::Svg Icon | path: icons/duotune/general/gen044.svg-->
        <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>
        <!--end::Svg Icon-->
        <!--end::Icon-->
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack flex-grow-1">
          <!--begin::Content-->
          <div class="fw-bold">
            <div class="fs-6 text-gray-700" *ngIf="!ExcelValidation.isValid">
              <div>
                {{utilityService.getResourceValue("UpdatedEntriesNumber")}} {{ExcelValidation.validCount}}
              </div>
              <div>
                {{utilityService.getResourceValue("InvalidEntriesNumber")}} {{ExcelValidation.invalidCount}}
              </div>
            </div>
            <div class="fs-6 text-gray-700" *ngIf="ExcelValidation.isValid">
              {{utilityService.getResourceValue("AllEntriesValid")}}
            </div>

          </div>
          <!--end::Content-->
        </div>
        <!--end::Wrapper-->
      </div>
      <div *ngIf="!ExcelValidation.isValid">
        <div class="table-responsive">
          <!-- begin::Table -->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150">{{utilityService.getResourceValue("ResourceId")}}</th>
                <th class="min-w-150">{{utilityService.getResourceValue("ResourceSet")}}</th>
                <th class="min-w-150">{{utilityService.getResourceValue("ErrorMessage")}}</th>
              </tr>
            </thead>
            <tbody class="fw-bold text-gray-600 border-0">
              <tr class="trItem" *ngFor="let Localization of ExcelValidation.invalidEntries">
                <td class="text-dark">
                  {{Localization.resourceId}}
                </td>
                <td>{{Localization.resourceSet}}</td>
                <td>{{Localization.errorMessage}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-center pt-7">
        <button type="button" #CloseResourceValidationModal id="CloseResourceValidationModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
        <button type="button" (click)="confirmExcel()" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
      </div>

    </div>
  </ng-template>

